import styled from "styled-components";
import fonts from "../../../styles/fonts";

const AppWrapper = styled.div`
  font-family: ${fonts.OpenSans};
  font-size: 1.6rem;
  display: flex;
  flex-direction: row;

  -webkit-print-color-adjust: exact !important;
`;

export default AppWrapper;
